export default __webpack_public_path__ + "static/media/airdockz-blk-banner-1.3fef04cb.jpg";